import { motion } from "framer-motion";
import {
  ChatCircleText,
  Lightning,
  ArrowsLeftRight,
  Target,
} from "@phosphor-icons/react";

const points = [
  {
    icon: ChatCircleText,
    title: "Clear communication",
    body: "You always know what's happening and why. Plain language, honest updates.",
    span: "md:col-span-2",
  },
  {
    icon: Lightning,
    title: "Quick responses",
    body: "I usually reply within a few hours.",
    span: "",
  },
  {
    icon: ArrowsLeftRight,
    title: "Straightforward process",
    body: "No hoops. No filler.",
    span: "",
  },
  {
    icon: Target,
    title: "Focus on real solutions",
    body: "The goal is simple — resolve your issue properly and get your account working again.",
    span: "md:col-span-2",
  },
];

export const Trust = () => {
  return (
    <section
      id="trust"
      data-testid="trust-section"
      className="max-w-[1400px] mx-auto px-5 sm:px-8 py-24 sm:py-36"
    >
      <div className="mb-16 max-w-3xl">
        <span className="font-code text-xs uppercase tracking-[0.2em] text-accent">
          [ 03 ] — Why people reach out
        </span>
        <h2 className="font-display font-bold tracking-tight leading-none text-4xl sm:text-5xl lg:text-6xl mt-5">
          Professional, responsive, and straightforward.
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-border border border-border">
        {points.map((p, i) => (
          <motion.div
            key={p.title}
            data-testid={`trust-point-${i}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className={`bg-background p-8 sm:p-10 hover:bg-card transition-colors duration-300 ${p.span}`}
          >
            <p.icon size={32} weight="duotone" className="text-accent mb-8" />
            <h3 className="font-display text-xl sm:text-2xl font-semibold tracking-tight mb-3">
              {p.title}
            </h3>
            <p className="font-body text-muted-foreground leading-relaxed">
              {p.body}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Trust;
